import {
	IconSize50,
	IconSize75,
	IconSize100,
	IconSize150,
	IconSize200,
	IconSize300,
	IconSize400,
	IconSize500,
	IconSize625,
	IconSize750,
} from "@mv/design-tokens/variables";
import { type SVGProps } from "react";
export interface Props
	extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
	size?:
		| "50"
		| "75"
		| "100"
		| "150"
		| "200"
		| "300"
		| "400"
		| "500"
		| "625"
		| "750";
}
const sizeMap = {
	50: IconSize50,
	75: IconSize75,
	100: IconSize100,
	150: IconSize150,
	200: IconSize200,
	300: IconSize300,
	400: IconSize400,
	500: IconSize500,
	625: IconSize625,
	750: IconSize750,
};
export default function IconComputerscreen({ size = "100", ...props }: Props) {
	return (
		<svg
			xmlns={"http://www.w3.org/2000/svg"}
			{...props}
			viewBox="0 0 24 24"
			width={sizeMap[size]}
			height={sizeMap[size]}
		>
			<defs>
				<path
					id="a"
					d="M19.737 1.538H1.207v.715c0 3.55.011 7.098-.01 10.647-.004.571.127.748.673.746 5.745-.023 11.491-.014 17.237-.014h.63z"
				/>
				<path id="c" d="M0 0v12.375h8.662c.38-.312.617-.82.587-1.382L8.66 0" />
				<path id="e" d="M0 0v12.375h8.662c.38-.312.617-.82.587-1.382L8.66 0" />
				<path id="g" d="M0 0v12.375h8.662c.38-.312.617-.82.587-1.382L8.66 0z" />
				<path id="i" d="M0 0v12.375h8.662c.38-.312.617-.82.587-1.382L8.66 0" />
				<path id="k" d="M0 0v12.375h8.662c.38-.312.617-.82.587-1.382L8.66 0" />
				<path id="m" d="M0 0v12.375h8.662c.38-.312.617-.82.587-1.382L8.66 0" />
				<path id="o" d="M0 0v12.375h8.662c.38-.312.617-.82.587-1.382L8.66 0" />
				<path id="q" d="M0 0v12.375h8.662c.38-.312.617-.82.587-1.382L8.66 0z" />
				<path id="s" d="M0 0v12.375h8.662c.38-.312.617-.82.587-1.382L8.66 0" />
				<path id="u" d="M0 0v12.375h8.662c.38-.312.617-.82.587-1.382L8.66 0" />
				<path
					id="w"
					d="M.6 0 .002 10.972c-.031.57.214 1.087.609 1.403h7.917V0"
				/>
				<path
					id="y"
					d="M.6 0 .002 10.972c-.031.57.214 1.087.609 1.403h7.917V0"
				/>
				<path
					id="A"
					d="M.6 0 .002 10.972c-.031.57.214 1.087.609 1.403h7.917V0z"
				/>
				<path
					id="C"
					d="M.6 0 .002 10.972c-.031.57.214 1.087.609 1.403h7.917V0"
				/>
				<path
					id="E"
					d="M.6 0 .002 10.972c-.031.57.214 1.087.609 1.403h7.917V0"
				/>
				<path
					id="G"
					d="M.6 0 .002 10.972c-.031.57.214 1.087.609 1.403h7.917V0"
				/>
				<path
					id="I"
					d="M.6 0 .002 10.972c-.031.57.214 1.087.609 1.403h7.917V0"
				/>
				<path
					id="K"
					d="M.6 0 .002 10.972c-.031.57.214 1.087.609 1.403h7.917V0z"
				/>
				<path
					id="M"
					d="M.6 0 .002 10.972c-.031.57.214 1.087.609 1.403h7.917V0"
				/>
				<path
					id="O"
					d="M.6 0 .002 10.972c-.031.57.214 1.087.609 1.403h7.917V0"
				/>
				<path id="Q" d="M0 0v12.375h8.662c.38-.312.617-.82.587-1.382L8.66 0" />
				<path id="S" d="M0 0v12.375h8.662c.38-.312.617-.82.587-1.382L8.66 0" />
				<path id="U" d="M0 0v12.375h8.662c.38-.312.617-.82.587-1.382L8.66 0z" />
				<path id="W" d="M0 0v12.375h8.662c.38-.312.617-.82.587-1.382L8.66 0" />
				<path id="Y" d="M0 0v12.375h8.662c.38-.312.617-.82.587-1.382L8.66 0" />
				<path id="aa" d="M0 0v12.375h8.662c.38-.312.617-.82.587-1.382L8.66 0" />
				<path id="ac" d="M0 0v12.375h8.662c.38-.312.617-.82.587-1.382L8.66 0" />
				<path
					id="ae"
					d="M0 0v12.375h8.662c.38-.312.617-.82.587-1.382L8.66 0z"
				/>
				<path id="ag" d="M0 0v12.375h8.662c.38-.312.617-.82.587-1.382L8.66 0" />
				<path id="ai" d="M0 0v12.375h8.662c.38-.312.617-.82.587-1.382L8.66 0" />
			</defs>
			<g fill="none" fillRule="evenodd" transform="translate(1.22 2.287)">
				<path
					fill="#E02020"
					d="M10.265 17.902v-1.688h1.623v1.719h4.17c1.122 0 1.253.157 1.174 1.46H4.773c-.149-1.24.019-1.46 1.103-1.46q1.882.001 3.766-.001c.187 0 .375-.018.623-.03m9.912-15.884H1.647v.715c0 3.55.011 7.098-.01 10.647-.004.571.127.748.673.746 5.745-.023 11.491-.014 17.237-.014h.63zM10.989.48h9.165c1.04.001 1.39.382 1.39 1.519q.003 6.176 0 12.351c0 1.138-.35 1.524-1.386 1.524q-9.165.003-18.33 0c-1.043 0-1.386-.377-1.387-1.52V2.003C.441.857.783.48 1.823.48q4.583-.002 9.166 0"
				/>
				<path
					fill="#FFF"
					d="M9.825 17.422v-1.688h1.623v1.719h4.17c1.122 0 1.253.157 1.174 1.46H4.333c-.149-1.24.019-1.46 1.103-1.46q1.882.001 3.766-.001c.187 0 .375-.018.623-.03m9.912-15.884H1.207v.715c0 3.55.011 7.098-.01 10.647-.004.571.127.748.673.746 5.745-.023 11.491-.014 17.237-.014h.63z"
				/>
				<path
					fill="#FFF"
					d="M10.549 0h9.165c1.04.001 1.39.382 1.39 1.519q.003 6.176 0 12.351c0 1.138-.35 1.524-1.386 1.524q-9.165.003-18.33 0c-1.043 0-1.386-.377-1.387-1.52V1.523C.001.377.343 0 1.383 0Q5.966 0 10.55.001"
				/>
				<mask id="b" fill="#fff">
					<use xlinkHref="#a" />
				</mask>
				<g mask="url(#b)">
					<g transform="translate(8.933 1.357)">
						<mask id="d" fill="#fff">
							<use xlinkHref="#c" />
						</mask>
						<path
							fill="#CD0400"
							d="M10.415.325c-.34 0-.506-.072-.682-.149a1.8 1.8 0 0 0-.806-.175c-.405 0-.618.093-.807.175a1.46 1.46 0 0 1-.68.15c-.34 0-.506-.073-.682-.15a1.8 1.8 0 0 0-.806-.175c-.405 0-.619.093-.807.175a1.46 1.46 0 0 1-.682.15 1.46 1.46 0 0 1-.681-.15 1.8 1.8 0 0 0-.806-.175c-.405 0-.618.093-.806.175a1.46 1.46 0 0 1-.683.15C1.148.325.982.252.806.175A1.8 1.8 0 0 0 0 .001v.366c.34 0 .506.072.681.149.189.083.402.176.806.176.405 0 .618-.093.807-.176.176-.077.342-.15.682-.15s.505.073.681.15c.188.083.402.176.806.176.405 0 .618-.093.807-.176a1.46 1.46 0 0 1 .682-.15c.339 0 .505.073.68.15.19.083.403.176.807.176s.618-.093.806-.176a1.46 1.46 0 0 1 .682-.15c.34 0 .505.073.681.15.19.083.402.176.807.176.403 0 .618-.093.806-.176a1.46 1.46 0 0 1 .681-.15V.002c-.404 0-.617.093-.806.175a1.46 1.46 0 0 1-.681.15"
							mask="url(#d)"
						/>
					</g>
					<g transform="translate(8.933 1.357)">
						<mask id="f" fill="#fff">
							<use xlinkHref="#e" />
						</mask>
						<path
							fill="#CD0400"
							d="M10.415 1.623c-.34 0-.506-.072-.682-.149a1.8 1.8 0 0 0-.806-.175c-.405 0-.618.093-.807.175a1.46 1.46 0 0 1-.68.15c-.34 0-.506-.073-.682-.15a1.8 1.8 0 0 0-.806-.175c-.405 0-.619.093-.807.175a1.46 1.46 0 0 1-.682.15 1.46 1.46 0 0 1-.681-.15 1.8 1.8 0 0 0-.806-.175c-.405 0-.618.093-.806.175a1.46 1.46 0 0 1-.683.15c-.339 0-.505-.073-.681-.15A1.8 1.8 0 0 0 0 1.3v.366c.34 0 .506.072.681.15.189.081.402.175.806.175.405 0 .618-.094.807-.176.176-.077.342-.149.682-.149s.505.072.681.15c.188.081.402.175.806.175.405 0 .618-.094.807-.176a1.46 1.46 0 0 1 .682-.149c.339 0 .505.072.68.15.19.081.403.175.807.175s.618-.094.806-.176a1.46 1.46 0 0 1 .682-.149c.34 0 .505.072.681.15.19.081.402.175.807.175.403 0 .618-.094.806-.176a1.46 1.46 0 0 1 .681-.149V1.3c-.404 0-.617.093-.806.175a1.46 1.46 0 0 1-.681.15"
							mask="url(#f)"
						/>
					</g>
					<g transform="translate(8.933 1.357)">
						<mask id="h" fill="#fff">
							<use xlinkHref="#g" />
						</mask>
						<path
							fill="#CD0400"
							d="M11.078 2.78c-.17.074-.335.141-.663.141s-.495-.067-.664-.14l-.018-.009c-.189-.082-.401-.175-.806-.175-.404 0-.618.093-.807.175l-.017.008c-.17.074-.336.141-.664.141s-.494-.067-.664-.14l-.018-.009c-.188-.082-.401-.175-.806-.175-.404 0-.618.093-.806.175l-.018.008c-.17.074-.335.141-.663.141s-.495-.067-.665-.14l-.017-.009c-.189-.082-.402-.175-.807-.175-.404 0-.617.093-.806.175l-.018.008c-.169.074-.335.141-.663.141-.329 0-.494-.067-.663-.14l-.019-.009C.618 2.69.404 2.597 0 2.597v.366c.34 0 .506.072.681.15.189.082.403.175.807.175s.617-.093.806-.176c.176-.077.342-.149.681-.149.34 0 .506.072.682.15.188.082.402.175.807.175.403 0 .618-.093.806-.176.175-.077.342-.149.681-.149.34 0 .506.072.682.15.188.082.402.175.806.175s.618-.093.806-.176c.177-.077.342-.149.682-.149s.506.072.681.15c.19.082.402.175.807.175.404 0 .618-.093.806-.176a1.46 1.46 0 0 1 .681-.149v-.366c-.404 0-.618.093-.806.175z"
							mask="url(#h)"
						/>
					</g>
					<g transform="translate(8.933 1.357)">
						<mask id="j" fill="#fff">
							<use xlinkHref="#i" />
						</mask>
						<path
							fill="#CD0400"
							d="M10.415 4.22c-.34 0-.506-.073-.682-.15a1.8 1.8 0 0 0-.806-.175c-.405 0-.618.093-.807.176a1.46 1.46 0 0 1-.68.149c-.34 0-.506-.073-.682-.15a1.8 1.8 0 0 0-.806-.175c-.405 0-.619.093-.807.176a1.46 1.46 0 0 1-.682.149 1.46 1.46 0 0 1-.681-.15 1.8 1.8 0 0 0-.806-.175c-.405 0-.618.093-.806.176a1.46 1.46 0 0 1-.683.149c-.339 0-.505-.073-.681-.15A1.8 1.8 0 0 0 0 3.896v.366c.34 0 .506.073.681.15.189.082.402.175.806.175.405 0 .618-.093.807-.176.176-.076.342-.149.682-.149s.505.073.681.15c.188.082.402.175.806.175.405 0 .618-.093.807-.176a1.46 1.46 0 0 1 .682-.149c.339 0 .505.073.68.15.19.082.403.175.807.175s.618-.093.806-.176a1.46 1.46 0 0 1 .682-.149c.34 0 .505.073.681.15.19.082.402.175.807.175.403 0 .618-.093.806-.176a1.46 1.46 0 0 1 .681-.149v-.366c-.404 0-.617.093-.806.176a1.46 1.46 0 0 1-.681.149"
							mask="url(#j)"
						/>
					</g>
					<g transform="translate(8.933 1.357)">
						<mask id="l" fill="#fff">
							<use xlinkHref="#k" />
						</mask>
						<path
							fill="#CD0400"
							d="M10.415 5.518c-.34 0-.506-.072-.682-.15a1.8 1.8 0 0 0-.806-.174c-.405 0-.618.093-.807.175a1.46 1.46 0 0 1-.68.149c-.34 0-.506-.072-.682-.15a1.8 1.8 0 0 0-.806-.174 1.8 1.8 0 0 0-.807.175 1.46 1.46 0 0 1-.682.149 1.46 1.46 0 0 1-.681-.15 1.8 1.8 0 0 0-.806-.174c-.405 0-.618.093-.806.175a1.46 1.46 0 0 1-.683.149c-.339 0-.505-.072-.681-.15A1.8 1.8 0 0 0 0 5.195v.366c.34 0 .506.072.681.149.189.082.402.175.806.175.405 0 .618-.093.807-.175.176-.077.342-.15.682-.15s.505.073.681.15c.188.082.402.175.806.175.405 0 .618-.093.807-.175a1.46 1.46 0 0 1 .682-.15c.339 0 .505.073.68.15.19.082.403.175.807.175s.618-.093.806-.175a1.46 1.46 0 0 1 .682-.15c.34 0 .505.073.681.15.19.082.402.175.807.175.403 0 .618-.093.806-.175a1.46 1.46 0 0 1 .681-.15v-.365c-.404 0-.617.093-.806.175a1.46 1.46 0 0 1-.681.149"
							mask="url(#l)"
						/>
					</g>
					<g transform="translate(8.933 1.357)">
						<mask id="n" fill="#fff">
							<use xlinkHref="#m" />
						</mask>
						<path
							fill="#CD0400"
							d="M10.415 6.816c-.34 0-.506-.072-.682-.149a1.8 1.8 0 0 0-.806-.175c-.405 0-.618.093-.807.175a1.46 1.46 0 0 1-.68.15c-.34 0-.506-.073-.682-.15a1.8 1.8 0 0 0-.806-.175c-.405 0-.619.093-.807.175a1.46 1.46 0 0 1-.682.15 1.46 1.46 0 0 1-.681-.15 1.8 1.8 0 0 0-.806-.175c-.405 0-.618.093-.806.175a1.46 1.46 0 0 1-.683.15c-.339 0-.505-.073-.681-.15A1.8 1.8 0 0 0 0 6.492v.366c.34 0 .506.073.681.149.189.082.402.175.806.175.405 0 .618-.093.807-.175.176-.076.342-.149.682-.149s.505.073.681.149c.188.082.402.175.806.175.405 0 .618-.093.807-.175.176-.076.341-.149.682-.149.339 0 .505.073.68.149.19.082.403.175.807.175s.618-.093.806-.175c.176-.076.342-.149.682-.149s.505.073.681.149c.19.082.402.175.807.175.403 0 .618-.093.806-.175.176-.076.342-.149.681-.149v-.366c-.404 0-.617.093-.806.175a1.46 1.46 0 0 1-.681.15"
							mask="url(#n)"
						/>
					</g>
					<g transform="translate(8.933 1.357)">
						<mask id="p" fill="#fff">
							<use xlinkHref="#o" />
						</mask>
						<path
							fill="#CD0400"
							d="M10.415 8.114c-.34 0-.506-.072-.682-.149a1.8 1.8 0 0 0-.806-.175c-.405 0-.618.093-.807.175a1.46 1.46 0 0 1-.68.15c-.34 0-.506-.073-.682-.15a1.8 1.8 0 0 0-.806-.175c-.405 0-.619.093-.807.175a1.46 1.46 0 0 1-.682.15 1.46 1.46 0 0 1-.681-.15 1.8 1.8 0 0 0-.806-.175c-.405 0-.618.093-.806.175a1.46 1.46 0 0 1-.683.15c-.339 0-.505-.073-.681-.15A1.8 1.8 0 0 0 0 7.79v.366c.34 0 .506.073.681.15.189.081.402.175.806.175.405 0 .618-.094.807-.176.176-.076.342-.149.682-.149s.505.073.681.15c.188.081.402.175.806.175.405 0 .618-.094.807-.176.176-.076.341-.149.682-.149.339 0 .505.073.68.15.19.081.403.175.807.175s.618-.094.806-.176c.176-.076.342-.149.682-.149s.505.073.681.15c.19.081.402.175.807.175.403 0 .618-.094.806-.176.176-.076.342-.149.681-.149V7.79c-.404 0-.617.093-.806.175a1.46 1.46 0 0 1-.681.15"
							mask="url(#p)"
						/>
					</g>
					<g transform="translate(8.933 1.357)">
						<mask id="r" fill="#fff">
							<use xlinkHref="#q" />
						</mask>
						<path
							fill="#CD0400"
							d="M11.078 9.271c-.17.074-.335.142-.663.142s-.495-.068-.664-.142l-.018-.008c-.189-.082-.401-.175-.806-.175-.404 0-.618.093-.807.175l-.017.008c-.17.074-.336.142-.664.142s-.494-.068-.664-.142l-.018-.008c-.188-.082-.401-.175-.806-.175-.404 0-.618.093-.806.175l-.018.008c-.17.074-.335.142-.663.142a1.45 1.45 0 0 1-.665-.142l-.017-.008c-.189-.082-.402-.175-.807-.175-.404 0-.617.093-.806.175l-.018.008c-.169.074-.335.142-.663.142-.329 0-.494-.068-.663-.142l-.019-.008C.618 9.18.404 9.088 0 9.088v.367c.34 0 .506.072.681.149.189.082.403.175.807.175s.617-.093.806-.175c.176-.077.342-.15.681-.15.34 0 .506.073.682.15.189.082.402.175.807.175.403 0 .618-.093.806-.175.175-.077.342-.15.681-.15.34 0 .506.073.682.15.188.082.402.175.806.175s.618-.093.806-.175c.177-.077.342-.15.682-.15s.506.073.681.15c.19.082.402.175.807.175.404 0 .618-.093.806-.175a1.46 1.46 0 0 1 .681-.15v-.366c-.404 0-.618.093-.806.175z"
							mask="url(#r)"
						/>
					</g>
					<g transform="translate(8.933 1.357)">
						<mask id="t" fill="#fff">
							<use xlinkHref="#s" />
						</mask>
						<path
							fill="#CD0400"
							d="M10.415 10.71c-.34 0-.506-.072-.682-.148a1.8 1.8 0 0 0-.806-.176c-.405 0-.618.093-.807.176a1.46 1.46 0 0 1-.68.149c-.34 0-.506-.073-.682-.15a1.8 1.8 0 0 0-.806-.175c-.405 0-.619.093-.807.176a1.46 1.46 0 0 1-.682.149 1.46 1.46 0 0 1-.681-.15 1.8 1.8 0 0 0-.806-.175c-.405 0-.618.093-.806.176a1.46 1.46 0 0 1-.683.149c-.339 0-.505-.073-.681-.15A1.8 1.8 0 0 0 0 10.387v.366c.34 0 .506.073.681.15.189.082.402.175.806.175.405 0 .618-.093.807-.176.176-.076.342-.149.682-.149s.505.073.681.15c.188.082.402.175.806.175.405 0 .618-.093.807-.176.176-.076.341-.149.682-.149.339 0 .505.073.68.15.19.082.403.175.807.175s.618-.093.806-.176c.176-.076.342-.149.682-.149s.505.073.681.15c.19.082.402.175.807.175.403 0 .618-.093.806-.176.176-.076.342-.149.681-.149v-.366c-.404 0-.617.093-.806.176a1.46 1.46 0 0 1-.681.149"
							mask="url(#t)"
						/>
					</g>
					<g transform="translate(8.933 1.357)">
						<mask id="v" fill="#fff">
							<use xlinkHref="#u" />
						</mask>
						<path
							fill="#CD0400"
							d="M10.415 12.009c-.34 0-.506-.072-.682-.149a1.8 1.8 0 0 0-.806-.175c-.405 0-.618.093-.807.175a1.46 1.46 0 0 1-.68.149c-.34 0-.506-.072-.682-.149a1.8 1.8 0 0 0-.806-.175 1.8 1.8 0 0 0-.807.175 1.46 1.46 0 0 1-.682.149 1.46 1.46 0 0 1-.681-.149 1.8 1.8 0 0 0-.806-.175c-.405 0-.618.093-.806.175a1.46 1.46 0 0 1-.683.149c-.339 0-.505-.072-.681-.149A1.8 1.8 0 0 0 0 11.685v.365c.34 0 .506.073.681.15.189.082.402.175.806.175.405 0 .618-.093.807-.175.176-.077.342-.15.682-.15s.505.073.681.15c.188.082.402.175.806.175.405 0 .618-.093.807-.175.176-.077.341-.15.682-.15.339 0 .505.073.68.15.19.082.403.175.807.175s.618-.093.806-.175c.176-.077.342-.15.682-.15s.505.073.681.15c.19.082.402.175.807.175.403 0 .618-.093.806-.175.176-.077.342-.15.681-.15v-.365c-.404 0-.617.093-.806.175a1.46 1.46 0 0 1-.681.149"
							mask="url(#v)"
						/>
					</g>
				</g>
				<g mask="url(#b)">
					<g transform="translate(.43 1.357)">
						<mask id="x" fill="#fff">
							<use xlinkHref="#w" />
						</mask>
						<path
							fill="#CD0400"
							d="M7.017.325c-.344 0-.513-.072-.692-.149a1.8 1.8 0 0 0-.819-.175c-.41 0-.627.093-.82.175a1.5 1.5 0 0 1-.691.15c-.345 0-.514-.073-.692-.15a1.8 1.8 0 0 0-.82-.175c-.41 0-.627.093-.818.175a1.5 1.5 0 0 1-.693.15C.627.325.458.252.28.175A1.8 1.8 0 0 0-.54.001c-.41 0-.627.093-.818.175a1.5 1.5 0 0 1-.694.15c-.344 0-.513-.073-.692-.15a1.8 1.8 0 0 0-.819-.175v.366c.346 0 .515.072.693.149.191.083.408.176.818.176.412 0 .628-.093.82-.176.179-.077.348-.15.692-.15.346 0 .514.073.693.15.19.083.408.176.819.176.41 0 .627-.093.82-.176.178-.077.346-.15.692-.15a1.5 1.5 0 0 1 .691.15c.192.083.41.176.82.176s.627-.093.819-.176c.179-.077.347-.15.692-.15s.514.073.692.15c.192.083.409.176.82.176.41 0 .627-.093.819-.176.178-.077.347-.15.692-.15V.002c-.41 0-.628.093-.82.175a1.5 1.5 0 0 1-.692.15"
							mask="url(#x)"
						/>
					</g>
					<g transform="translate(.43 1.357)">
						<mask id="z" fill="#fff">
							<use xlinkHref="#y" />
						</mask>
						<path
							fill="#CD0400"
							d="M7.017 1.623c-.344 0-.513-.072-.692-.149a1.8 1.8 0 0 0-.819-.175c-.41 0-.627.093-.82.175a1.5 1.5 0 0 1-.691.15c-.345 0-.514-.073-.692-.15a1.8 1.8 0 0 0-.82-.175c-.41 0-.627.093-.818.175a1.5 1.5 0 0 1-.693.15c-.345 0-.514-.073-.692-.15A1.8 1.8 0 0 0-.54 1.3c-.41 0-.627.093-.818.175a1.5 1.5 0 0 1-.694.15c-.344 0-.513-.073-.692-.15a1.8 1.8 0 0 0-.819-.175v.366c.346 0 .515.072.693.15.191.081.408.175.818.175.412 0 .628-.094.82-.176.179-.077.348-.149.692-.149.346 0 .514.072.693.15.19.081.408.175.819.175.41 0 .627-.094.82-.176.178-.077.346-.149.692-.149a1.5 1.5 0 0 1 .691.15c.192.081.41.175.82.175s.627-.094.819-.176c.179-.077.347-.149.692-.149s.514.072.692.15c.192.081.409.175.82.175.41 0 .627-.094.819-.176.178-.077.347-.149.692-.149V1.3c-.41 0-.628.093-.82.175a1.5 1.5 0 0 1-.692.15"
							mask="url(#z)"
						/>
					</g>
					<g transform="translate(.43 1.357)">
						<mask id="B" fill="#fff">
							<use xlinkHref="#A" />
						</mask>
						<path
							fill="#CD0400"
							d="M7.691 2.78a1.5 1.5 0 0 1-.673.141 1.5 1.5 0 0 1-.675-.14l-.018-.009c-.192-.082-.408-.175-.819-.175-.41 0-.628.093-.82.175l-.017.008a1.5 1.5 0 0 1-.674.141 1.5 1.5 0 0 1-.675-.14l-.018-.009c-.191-.082-.408-.175-.819-.175-.41 0-.628.093-.82.175l-.018.008c-.171.074-.34.141-.673.141-.334 0-.502-.067-.675-.14L.28 2.771c-.192-.082-.409-.175-.82-.175-.41 0-.627.093-.819.175l-.019.008c-.17.074-.34.141-.673.141-.334 0-.502-.067-.674-.14l-.018-.009c-.191-.082-.409-.175-.82-.175v.366c.345 0 .514.072.693.15.191.082.408.175.819.175.41 0 .627-.093.819-.176.179-.077.347-.149.692-.149s.514.072.693.15c.191.082.408.175.82.175.41 0 .627-.093.818-.176.178-.077.347-.149.692-.149s.514.072.693.15c.191.082.408.175.819.175.41 0 .627-.093.819-.176.179-.077.347-.149.692-.149s.514.072.692.15c.192.082.409.175.82.175.41 0 .627-.093.819-.176.178-.077.347-.149.692-.149v-.366c-.41 0-.628.093-.82.175z"
							mask="url(#B)"
						/>
					</g>
					<g transform="translate(.43 1.357)">
						<mask id="D" fill="#fff">
							<use xlinkHref="#C" />
						</mask>
						<path
							fill="#CD0400"
							d="M7.017 4.22c-.344 0-.513-.073-.692-.15a1.8 1.8 0 0 0-.819-.175c-.41 0-.627.093-.82.176a1.5 1.5 0 0 1-.691.149c-.345 0-.514-.073-.692-.15a1.8 1.8 0 0 0-.82-.175c-.41 0-.627.093-.818.176a1.5 1.5 0 0 1-.693.149c-.345 0-.514-.073-.692-.15a1.8 1.8 0 0 0-.82-.175c-.41 0-.627.093-.818.176a1.5 1.5 0 0 1-.694.149c-.344 0-.513-.073-.692-.15a1.8 1.8 0 0 0-.819-.175v.366c.346 0 .515.073.693.15.191.082.408.175.818.175.412 0 .628-.093.82-.176.179-.076.348-.149.692-.149.346 0 .514.073.693.15.19.082.408.175.819.175.41 0 .627-.093.82-.176.178-.076.346-.149.692-.149a1.5 1.5 0 0 1 .691.15c.192.082.41.175.82.175s.627-.093.819-.176c.179-.076.347-.149.692-.149s.514.073.692.15c.192.082.409.175.82.175.41 0 .627-.093.819-.176.178-.076.347-.149.692-.149v-.366c-.41 0-.628.093-.82.176a1.5 1.5 0 0 1-.692.149"
							mask="url(#D)"
						/>
					</g>
					<g transform="translate(.43 1.357)">
						<mask id="F" fill="#fff">
							<use xlinkHref="#E" />
						</mask>
						<path
							fill="#CD0400"
							d="M7.017 5.518c-.344 0-.513-.072-.692-.15a1.8 1.8 0 0 0-.819-.174c-.41 0-.627.093-.82.175a1.5 1.5 0 0 1-.691.149c-.345 0-.514-.072-.692-.15a1.8 1.8 0 0 0-.82-.174 1.8 1.8 0 0 0-.819.175 1.5 1.5 0 0 1-.692.149c-.345 0-.514-.072-.692-.15a1.8 1.8 0 0 0-.82-.174c-.41 0-.627.093-.818.175a1.5 1.5 0 0 1-.694.149c-.344 0-.513-.072-.692-.15a1.8 1.8 0 0 0-.819-.174v.366c.346 0 .515.072.693.149.191.082.408.175.818.175.412 0 .628-.093.82-.175.179-.077.348-.15.692-.15.346 0 .514.073.693.15.19.082.408.175.819.175.41 0 .627-.093.82-.175.178-.077.346-.15.692-.15a1.5 1.5 0 0 1 .691.15c.192.082.41.175.82.175s.627-.093.819-.175c.179-.077.347-.15.692-.15s.514.073.692.15c.192.082.409.175.82.175.41 0 .627-.093.819-.175.178-.077.347-.15.692-.15v-.365c-.41 0-.628.093-.82.175a1.5 1.5 0 0 1-.692.149"
							mask="url(#F)"
						/>
					</g>
					<g transform="translate(.43 1.357)">
						<mask id="H" fill="#fff">
							<use xlinkHref="#G" />
						</mask>
						<path
							fill="#CD0400"
							d="M7.017 6.816c-.344 0-.513-.072-.692-.149a1.8 1.8 0 0 0-.819-.175c-.41 0-.627.093-.82.175a1.5 1.5 0 0 1-.691.15c-.345 0-.514-.073-.692-.15a1.8 1.8 0 0 0-.82-.175c-.41 0-.627.093-.818.175a1.5 1.5 0 0 1-.693.15c-.345 0-.514-.073-.692-.15a1.8 1.8 0 0 0-.82-.175c-.41 0-.627.093-.818.175a1.5 1.5 0 0 1-.694.15c-.344 0-.513-.073-.692-.15a1.8 1.8 0 0 0-.819-.175v.366c.346 0 .515.073.693.149.191.082.408.175.818.175.412 0 .628-.093.82-.175.179-.076.348-.149.692-.149.346 0 .514.073.693.149.19.082.408.175.819.175.41 0 .627-.093.82-.175.178-.076.346-.149.692-.149.344 0 .513.073.691.149.192.082.41.175.82.175s.627-.093.819-.175c.179-.076.347-.149.692-.149s.514.073.692.149c.192.082.409.175.82.175.41 0 .627-.093.819-.175.178-.076.347-.149.692-.149v-.366c-.41 0-.628.093-.82.175a1.5 1.5 0 0 1-.692.15"
							mask="url(#H)"
						/>
					</g>
					<g transform="translate(.43 1.357)">
						<mask id="J" fill="#fff">
							<use xlinkHref="#I" />
						</mask>
						<path
							fill="#CD0400"
							d="M7.017 8.114c-.344 0-.513-.072-.692-.149a1.8 1.8 0 0 0-.819-.175c-.41 0-.627.093-.82.175a1.5 1.5 0 0 1-.691.15c-.345 0-.514-.073-.692-.15a1.8 1.8 0 0 0-.82-.175c-.41 0-.627.093-.818.175a1.5 1.5 0 0 1-.693.15c-.345 0-.514-.073-.692-.15a1.8 1.8 0 0 0-.82-.175c-.41 0-.627.093-.818.175a1.5 1.5 0 0 1-.694.15c-.344 0-.513-.073-.692-.15a1.8 1.8 0 0 0-.819-.175v.366c.346 0 .515.073.693.15.191.081.408.175.818.175.412 0 .628-.094.82-.176.179-.076.348-.149.692-.149.346 0 .514.073.693.15.19.081.408.175.819.175.41 0 .627-.094.82-.176.178-.076.346-.149.692-.149.344 0 .513.073.691.15.192.081.41.175.82.175s.627-.094.819-.176c.179-.076.347-.149.692-.149s.514.073.692.15c.192.081.409.175.82.175.41 0 .627-.094.819-.176.178-.076.347-.149.692-.149V7.79c-.41 0-.628.093-.82.175a1.5 1.5 0 0 1-.692.15"
							mask="url(#J)"
						/>
					</g>
					<g transform="translate(.43 1.357)">
						<mask id="L" fill="#fff">
							<use xlinkHref="#K" />
						</mask>
						<path
							fill="#CD0400"
							d="M7.691 9.271a1.5 1.5 0 0 1-.673.142c-.333 0-.503-.068-.675-.142l-.018-.008c-.192-.082-.408-.175-.819-.175-.41 0-.628.093-.82.175l-.017.008a1.5 1.5 0 0 1-.674.142 1.5 1.5 0 0 1-.675-.142l-.018-.008c-.191-.082-.408-.175-.819-.175-.41 0-.628.093-.82.175l-.018.008c-.171.074-.34.142-.673.142-.334 0-.502-.068-.675-.142L.28 9.263c-.192-.082-.409-.175-.82-.175-.41 0-.627.093-.819.175l-.019.008c-.17.074-.34.142-.673.142-.334 0-.502-.068-.674-.142l-.018-.008c-.191-.082-.409-.175-.82-.175v.367c.345 0 .514.072.693.149.191.082.408.175.819.175.41 0 .627-.093.819-.175.179-.077.347-.15.692-.15s.514.073.693.15c.191.082.408.175.82.175.41 0 .627-.093.818-.175.178-.077.347-.15.692-.15s.514.073.693.15c.191.082.408.175.819.175.41 0 .627-.093.819-.175.179-.077.347-.15.692-.15s.514.073.692.15c.192.082.409.175.82.175.41 0 .627-.093.819-.175.178-.077.347-.15.692-.15v-.366c-.41 0-.628.093-.82.175z"
							mask="url(#L)"
						/>
					</g>
					<g transform="translate(.43 1.357)">
						<mask id="N" fill="#fff">
							<use xlinkHref="#M" />
						</mask>
						<path
							fill="#CD0400"
							d="M7.017 10.71c-.344 0-.513-.072-.692-.148a1.8 1.8 0 0 0-.819-.176c-.41 0-.627.093-.82.176a1.5 1.5 0 0 1-.691.149c-.345 0-.514-.073-.692-.15a1.8 1.8 0 0 0-.82-.175c-.41 0-.627.093-.818.176a1.5 1.5 0 0 1-.693.149c-.345 0-.514-.073-.692-.15a1.8 1.8 0 0 0-.82-.175c-.41 0-.627.093-.818.176a1.5 1.5 0 0 1-.694.149c-.344 0-.513-.073-.692-.15a1.8 1.8 0 0 0-.819-.175v.366c.346 0 .515.073.693.15.191.082.408.175.818.175.412 0 .628-.093.82-.176.179-.076.348-.149.692-.149.346 0 .514.073.693.15.19.082.408.175.819.175.41 0 .627-.093.82-.176.178-.076.346-.149.692-.149.344 0 .513.073.691.15.192.082.41.175.82.175s.627-.093.819-.176c.179-.076.347-.149.692-.149s.514.073.692.15c.192.082.409.175.82.175.41 0 .627-.093.819-.176.178-.076.347-.149.692-.149v-.366c-.41 0-.628.093-.82.176a1.5 1.5 0 0 1-.692.149"
							mask="url(#N)"
						/>
					</g>
					<g transform="translate(.43 1.357)">
						<mask id="P" fill="#fff">
							<use xlinkHref="#O" />
						</mask>
						<path
							fill="#CD0400"
							d="M7.017 12.009c-.344 0-.513-.072-.692-.149a1.8 1.8 0 0 0-.819-.175c-.41 0-.627.093-.82.175a1.5 1.5 0 0 1-.691.149c-.345 0-.514-.072-.692-.149a1.8 1.8 0 0 0-.82-.175 1.8 1.8 0 0 0-.819.175 1.5 1.5 0 0 1-.692.149c-.345 0-.514-.072-.692-.149a1.8 1.8 0 0 0-.82-.175c-.41 0-.627.093-.818.175a1.5 1.5 0 0 1-.694.149c-.344 0-.513-.072-.692-.149a1.8 1.8 0 0 0-.819-.175v.365a1.5 1.5 0 0 1 .693.15c.191.082.408.175.818.175.412 0 .628-.093.82-.175.179-.077.348-.15.692-.15.346 0 .514.073.693.15.19.082.408.175.819.175.41 0 .627-.093.82-.175.178-.077.346-.15.692-.15.344 0 .513.073.691.15.192.082.41.175.82.175s.627-.093.819-.175c.179-.077.347-.15.692-.15s.514.073.692.15c.192.082.409.175.82.175.41 0 .627-.093.819-.175.178-.077.347-.15.692-.15v-.365c-.41 0-.628.093-.82.175a1.5 1.5 0 0 1-.692.149"
							mask="url(#P)"
						/>
					</g>
				</g>
				<g mask="url(#b)">
					<g transform="translate(17.513 1.357)">
						<mask id="R" fill="#fff">
							<use xlinkHref="#Q" />
						</mask>
						<path
							fill="#CD0400"
							d="M10.415.325c-.34 0-.506-.072-.682-.149a1.8 1.8 0 0 0-.806-.175c-.405 0-.618.093-.807.175a1.46 1.46 0 0 1-.68.15c-.34 0-.506-.073-.682-.15a1.8 1.8 0 0 0-.806-.175c-.405 0-.619.093-.807.175a1.46 1.46 0 0 1-.682.15 1.46 1.46 0 0 1-.681-.15 1.8 1.8 0 0 0-.806-.175c-.405 0-.618.093-.806.175a1.46 1.46 0 0 1-.683.15C1.148.325.982.252.806.175A1.8 1.8 0 0 0 0 .001v.366c.34 0 .506.072.681.149.189.083.402.176.806.176.405 0 .618-.093.807-.176.176-.077.342-.15.682-.15s.505.073.681.15c.188.083.402.176.806.176.405 0 .618-.093.807-.176a1.46 1.46 0 0 1 .682-.15c.339 0 .505.073.68.15.19.083.403.176.807.176s.618-.093.806-.176a1.46 1.46 0 0 1 .682-.15c.34 0 .505.073.681.15.19.083.402.176.807.176.403 0 .618-.093.806-.176a1.46 1.46 0 0 1 .681-.15V.002c-.404 0-.617.093-.806.175a1.46 1.46 0 0 1-.681.15"
							mask="url(#R)"
						/>
					</g>
					<g transform="translate(17.513 1.357)">
						<mask id="T" fill="#fff">
							<use xlinkHref="#S" />
						</mask>
						<path
							fill="#CD0400"
							d="M10.415 1.623c-.34 0-.506-.072-.682-.149a1.8 1.8 0 0 0-.806-.175c-.405 0-.618.093-.807.175a1.46 1.46 0 0 1-.68.15c-.34 0-.506-.073-.682-.15a1.8 1.8 0 0 0-.806-.175c-.405 0-.619.093-.807.175a1.46 1.46 0 0 1-.682.15 1.46 1.46 0 0 1-.681-.15 1.8 1.8 0 0 0-.806-.175c-.405 0-.618.093-.806.175a1.46 1.46 0 0 1-.683.15c-.339 0-.505-.073-.681-.15A1.8 1.8 0 0 0 0 1.3v.366c.34 0 .506.072.681.15.189.081.402.175.806.175.405 0 .618-.094.807-.176.176-.077.342-.149.682-.149s.505.072.681.15c.188.081.402.175.806.175.405 0 .618-.094.807-.176a1.46 1.46 0 0 1 .682-.149c.339 0 .505.072.68.15.19.081.403.175.807.175s.618-.094.806-.176a1.46 1.46 0 0 1 .682-.149c.34 0 .505.072.681.15.19.081.402.175.807.175.403 0 .618-.094.806-.176a1.46 1.46 0 0 1 .681-.149V1.3c-.404 0-.617.093-.806.175a1.46 1.46 0 0 1-.681.15"
							mask="url(#T)"
						/>
					</g>
					<g transform="translate(17.513 1.357)">
						<mask id="V" fill="#fff">
							<use xlinkHref="#U" />
						</mask>
						<path
							fill="#CD0400"
							d="M11.078 2.78c-.17.074-.335.141-.663.141s-.495-.067-.664-.14l-.018-.009c-.189-.082-.401-.175-.806-.175-.404 0-.618.093-.807.175l-.017.008c-.17.074-.336.141-.664.141s-.494-.067-.664-.14l-.018-.009c-.188-.082-.401-.175-.806-.175-.404 0-.618.093-.806.175l-.018.008c-.17.074-.335.141-.663.141s-.495-.067-.665-.14l-.017-.009c-.189-.082-.402-.175-.807-.175-.404 0-.617.093-.806.175l-.018.008c-.169.074-.335.141-.663.141-.329 0-.494-.067-.663-.14l-.019-.009C.618 2.69.404 2.597 0 2.597v.366c.34 0 .506.072.681.15.189.082.403.175.807.175s.617-.093.806-.176c.176-.077.342-.149.681-.149.34 0 .506.072.682.15.188.082.402.175.807.175.403 0 .618-.093.806-.176.175-.077.342-.149.681-.149.34 0 .506.072.682.15.188.082.402.175.806.175s.618-.093.806-.176c.177-.077.342-.149.682-.149s.506.072.681.15c.19.082.402.175.807.175.404 0 .618-.093.806-.176a1.46 1.46 0 0 1 .681-.149v-.366c-.404 0-.618.093-.806.175z"
							mask="url(#V)"
						/>
					</g>
					<g transform="translate(17.513 1.357)">
						<mask id="X" fill="#fff">
							<use xlinkHref="#W" />
						</mask>
						<path
							fill="#CD0400"
							d="M10.415 4.22c-.34 0-.506-.073-.682-.15a1.8 1.8 0 0 0-.806-.175c-.405 0-.618.093-.807.176a1.46 1.46 0 0 1-.68.149c-.34 0-.506-.073-.682-.15a1.8 1.8 0 0 0-.806-.175c-.405 0-.619.093-.807.176a1.46 1.46 0 0 1-.682.149 1.46 1.46 0 0 1-.681-.15 1.8 1.8 0 0 0-.806-.175c-.405 0-.618.093-.806.176a1.46 1.46 0 0 1-.683.149c-.339 0-.505-.073-.681-.15A1.8 1.8 0 0 0 0 3.896v.366c.34 0 .506.073.681.15.189.082.402.175.806.175.405 0 .618-.093.807-.176.176-.076.342-.149.682-.149s.505.073.681.15c.188.082.402.175.806.175.405 0 .618-.093.807-.176a1.46 1.46 0 0 1 .682-.149c.339 0 .505.073.68.15.19.082.403.175.807.175s.618-.093.806-.176a1.46 1.46 0 0 1 .682-.149c.34 0 .505.073.681.15.19.082.402.175.807.175.403 0 .618-.093.806-.176a1.46 1.46 0 0 1 .681-.149v-.366c-.404 0-.617.093-.806.176a1.46 1.46 0 0 1-.681.149"
							mask="url(#X)"
						/>
					</g>
					<g transform="translate(17.513 1.357)">
						<mask id="Z" fill="#fff">
							<use xlinkHref="#Y" />
						</mask>
						<path
							fill="#CD0400"
							d="M10.415 5.518c-.34 0-.506-.072-.682-.15a1.8 1.8 0 0 0-.806-.174c-.405 0-.618.093-.807.175a1.46 1.46 0 0 1-.68.149c-.34 0-.506-.072-.682-.15a1.8 1.8 0 0 0-.806-.174 1.8 1.8 0 0 0-.807.175 1.46 1.46 0 0 1-.682.149 1.46 1.46 0 0 1-.681-.15 1.8 1.8 0 0 0-.806-.174c-.405 0-.618.093-.806.175a1.46 1.46 0 0 1-.683.149c-.339 0-.505-.072-.681-.15A1.8 1.8 0 0 0 0 5.195v.366c.34 0 .506.072.681.149.189.082.402.175.806.175.405 0 .618-.093.807-.175.176-.077.342-.15.682-.15s.505.073.681.15c.188.082.402.175.806.175.405 0 .618-.093.807-.175a1.46 1.46 0 0 1 .682-.15c.339 0 .505.073.68.15.19.082.403.175.807.175s.618-.093.806-.175a1.46 1.46 0 0 1 .682-.15c.34 0 .505.073.681.15.19.082.402.175.807.175.403 0 .618-.093.806-.175a1.46 1.46 0 0 1 .681-.15v-.365c-.404 0-.617.093-.806.175a1.46 1.46 0 0 1-.681.149"
							mask="url(#Z)"
						/>
					</g>
					<g transform="translate(17.513 1.357)">
						<mask id="ab" fill="#fff">
							<use xlinkHref="#aa" />
						</mask>
						<path
							fill="#CD0400"
							d="M10.415 6.816c-.34 0-.506-.072-.682-.149a1.8 1.8 0 0 0-.806-.175c-.405 0-.618.093-.807.175a1.46 1.46 0 0 1-.68.15c-.34 0-.506-.073-.682-.15a1.8 1.8 0 0 0-.806-.175c-.405 0-.619.093-.807.175a1.46 1.46 0 0 1-.682.15 1.46 1.46 0 0 1-.681-.15 1.8 1.8 0 0 0-.806-.175c-.405 0-.618.093-.806.175a1.46 1.46 0 0 1-.683.15c-.339 0-.505-.073-.681-.15A1.8 1.8 0 0 0 0 6.492v.366c.34 0 .506.073.681.149.189.082.402.175.806.175.405 0 .618-.093.807-.175.176-.076.342-.149.682-.149s.505.073.681.149c.188.082.402.175.806.175.405 0 .618-.093.807-.175.176-.076.341-.149.682-.149.339 0 .505.073.68.149.19.082.403.175.807.175s.618-.093.806-.175c.176-.076.342-.149.682-.149s.505.073.681.149c.19.082.402.175.807.175.403 0 .618-.093.806-.175.176-.076.342-.149.681-.149v-.366c-.404 0-.617.093-.806.175a1.46 1.46 0 0 1-.681.15"
							mask="url(#ab)"
						/>
					</g>
					<g transform="translate(17.513 1.357)">
						<mask id="ad" fill="#fff">
							<use xlinkHref="#ac" />
						</mask>
						<path
							fill="#CD0400"
							d="M10.415 8.114c-.34 0-.506-.072-.682-.149a1.8 1.8 0 0 0-.806-.175c-.405 0-.618.093-.807.175a1.46 1.46 0 0 1-.68.15c-.34 0-.506-.073-.682-.15a1.8 1.8 0 0 0-.806-.175c-.405 0-.619.093-.807.175a1.46 1.46 0 0 1-.682.15 1.46 1.46 0 0 1-.681-.15 1.8 1.8 0 0 0-.806-.175c-.405 0-.618.093-.806.175a1.46 1.46 0 0 1-.683.15c-.339 0-.505-.073-.681-.15A1.8 1.8 0 0 0 0 7.79v.366c.34 0 .506.073.681.15.189.081.402.175.806.175.405 0 .618-.094.807-.176.176-.076.342-.149.682-.149s.505.073.681.15c.188.081.402.175.806.175.405 0 .618-.094.807-.176.176-.076.341-.149.682-.149.339 0 .505.073.68.15.19.081.403.175.807.175s.618-.094.806-.176c.176-.076.342-.149.682-.149s.505.073.681.15c.19.081.402.175.807.175.403 0 .618-.094.806-.176.176-.076.342-.149.681-.149V7.79c-.404 0-.617.093-.806.175a1.46 1.46 0 0 1-.681.15"
							mask="url(#ad)"
						/>
					</g>
					<g transform="translate(17.513 1.357)">
						<mask id="af" fill="#fff">
							<use xlinkHref="#ae" />
						</mask>
						<path
							fill="#CD0400"
							d="M11.078 9.271c-.17.074-.335.142-.663.142s-.495-.068-.664-.142l-.018-.008c-.189-.082-.401-.175-.806-.175-.404 0-.618.093-.807.175l-.017.008c-.17.074-.336.142-.664.142s-.494-.068-.664-.142l-.018-.008c-.188-.082-.401-.175-.806-.175-.404 0-.618.093-.806.175l-.018.008c-.17.074-.335.142-.663.142a1.45 1.45 0 0 1-.665-.142l-.017-.008c-.189-.082-.402-.175-.807-.175-.404 0-.617.093-.806.175l-.018.008c-.169.074-.335.142-.663.142-.329 0-.494-.068-.663-.142l-.019-.008C.618 9.18.404 9.088 0 9.088v.367c.34 0 .506.072.681.149.189.082.403.175.807.175s.617-.093.806-.175c.176-.077.342-.15.681-.15.34 0 .506.073.682.15.189.082.402.175.807.175.403 0 .618-.093.806-.175.175-.077.342-.15.681-.15.34 0 .506.073.682.15.188.082.402.175.806.175s.618-.093.806-.175c.177-.077.342-.15.682-.15s.506.073.681.15c.19.082.402.175.807.175.404 0 .618-.093.806-.175a1.46 1.46 0 0 1 .681-.15v-.366c-.404 0-.618.093-.806.175z"
							mask="url(#af)"
						/>
					</g>
					<g transform="translate(17.513 1.357)">
						<mask id="ah" fill="#fff">
							<use xlinkHref="#ag" />
						</mask>
						<path
							fill="#CD0400"
							d="M10.415 10.71c-.34 0-.506-.072-.682-.148a1.8 1.8 0 0 0-.806-.176c-.405 0-.618.093-.807.176a1.46 1.46 0 0 1-.68.149c-.34 0-.506-.073-.682-.15a1.8 1.8 0 0 0-.806-.175c-.405 0-.619.093-.807.176a1.46 1.46 0 0 1-.682.149 1.46 1.46 0 0 1-.681-.15 1.8 1.8 0 0 0-.806-.175c-.405 0-.618.093-.806.176a1.46 1.46 0 0 1-.683.149c-.339 0-.505-.073-.681-.15A1.8 1.8 0 0 0 0 10.387v.366c.34 0 .506.073.681.15.189.082.402.175.806.175.405 0 .618-.093.807-.176.176-.076.342-.149.682-.149s.505.073.681.15c.188.082.402.175.806.175.405 0 .618-.093.807-.176.176-.076.341-.149.682-.149.339 0 .505.073.68.15.19.082.403.175.807.175s.618-.093.806-.176c.176-.076.342-.149.682-.149s.505.073.681.15c.19.082.402.175.807.175.403 0 .618-.093.806-.176.176-.076.342-.149.681-.149v-.366c-.404 0-.617.093-.806.176a1.46 1.46 0 0 1-.681.149"
							mask="url(#ah)"
						/>
					</g>
					<g transform="translate(17.513 1.357)">
						<mask id="aj" fill="#fff">
							<use xlinkHref="#ai" />
						</mask>
						<path
							fill="#CD0400"
							d="M10.415 12.009c-.34 0-.506-.072-.682-.149a1.8 1.8 0 0 0-.806-.175c-.405 0-.618.093-.807.175a1.46 1.46 0 0 1-.68.149c-.34 0-.506-.072-.682-.149a1.8 1.8 0 0 0-.806-.175 1.8 1.8 0 0 0-.807.175 1.46 1.46 0 0 1-.682.149 1.46 1.46 0 0 1-.681-.149 1.8 1.8 0 0 0-.806-.175c-.405 0-.618.093-.806.175a1.46 1.46 0 0 1-.683.149c-.339 0-.505-.072-.681-.149A1.8 1.8 0 0 0 0 11.685v.365c.34 0 .506.073.681.15.189.082.402.175.806.175.405 0 .618-.093.807-.175.176-.077.342-.15.682-.15s.505.073.681.15c.188.082.402.175.806.175.405 0 .618-.093.807-.175.176-.077.341-.15.682-.15.339 0 .505.073.68.15.19.082.403.175.807.175s.618-.093.806-.175c.176-.077.342-.15.682-.15s.505.073.681.15c.19.082.402.175.807.175.403 0 .618-.093.806-.175.176-.077.342-.15.681-.15v-.365c-.404 0-.617.093-.806.175a1.46 1.46 0 0 1-.681.149"
							mask="url(#aj)"
						/>
					</g>
				</g>
			</g>
		</svg>
	);
}
